import React, { useEffect, useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { Modal, Button, Form } from 'react-bootstrap';
import { format, parseISO, isToday, isAfter, endOfDay } from 'date-fns';
import { fetchMeetingsData } from '../PublicUserProfile/api';
import { useParams } from 'react-router-dom';
// import { format, parseISO } from 'date-fns';

interface Meeting {
  id: number;
  start_time: string;
  end_time: string;
  notes: string;
  booked: boolean;
}

export default function PublicCalendarPage() {
  const [meetings, setMeetings] = useState<Meeting[]>([]);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [filteredMeetings, setFilteredMeetings] = useState<Meeting[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [notes, setNotes] = useState('');
  const { username } = useParams<{ username: string }>();

  useEffect(() => {
    const loadMeetings = async (username: string) => {
      const data = await fetchMeetingsData(username);
      setMeetings(data || []);
    };
    if (username) {
      loadMeetings(username);
    }
  }, [username]);

  const handleDateClick = (date: Date) => {
    setSelectedDate(date);
    const dayStart = date.toISOString().split('T')[0];
    const sameDayMeetings = meetings.filter((meeting) => meeting.start_time.startsWith(dayStart));
    setFilteredMeetings(sameDayMeetings);
  };

  const canBookToday =
    selectedDate && isToday(selectedDate)
      ? isAfter(endOfDay(new Date()), new Date()) // Check if day isn't over
      : isAfter(endOfDay(selectedDate!), new Date());

  const handleBooking = () => {
    // You should call the booking API here
    console.log('Booking meeting with notes:', notes);
    setShowModal(false);
  };

  return (
    <div className="container mt-4">
      <h2>Public Calendar</h2>
      <Calendar
        selectRange={false}
        onClickDay={handleDateClick}
        value={selectedDate}
        onChange={(date) => {
          if (date instanceof Date) setSelectedDate(date);
        }}
        tileContent={({ date, view }) => {
          if (view === 'month') {
            const calendarDateStr = date.toISOString().slice(0, 10);
            const hasMeeting = meetings.some((m) => {
              const meetingDateStr = parseISO(m.start_time).toISOString().slice(0, 10);
              return meetingDateStr === calendarDateStr;
            });

            if (hasMeeting) {
              return (
                <div
                  style={{
                    backgroundColor: '#cce5ff',
                    borderRadius: '50%',
                    width: '80%',
                    height: '80%',
                    margin: '0 auto',
                  }}
                />
              );
            }
          }
          return null;
        }}
      />

      {selectedDate && (
        <div className="mt-3">
          <h4>Meetings on {format(selectedDate, 'PPP')}:</h4>
          {filteredMeetings.length > 0 ? (
            filteredMeetings.map((meeting) => (
              <div key={meeting.id} className="border p-2 my-2">
                <strong>
                  {format(new Date(meeting.start_time), 'p')} -{' '}
                  {format(new Date(meeting.end_time), 'p')}
                </strong>
                <p>{meeting.notes}</p>
                <p>
                  Status:{' '}
                  {meeting.booked ? (
                    <span className="text-danger">Booked</span>
                  ) : (
                    <span className="text-success">Available</span>
                  )}
                </p>
              </div>
            ))
          ) : (
            <p>No meetings yet for this day.</p>
          )}

          {canBookToday && (
            <Button variant="primary" onClick={() => setShowModal(true)}>
              Book a Meeting
            </Button>
          )}
        </div>
      )}

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Book Meeting on {selectedDate && format(selectedDate, 'PPP')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="meetingNotes">
              <Form.Label>Notes</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleBooking}>
            Submit Booking
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
